import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";

const Navbar = () => {
    const [isSticky, setIsSticky] = useState(false);
    const location = useLocation();
    // useEffect(() => {
    //   const handleScroll = () => {
    //     // Scroll 50px ke baad sticky class add karo
    //     if (window.scrollY > 10) {
    //       setIsSticky(true);
    //     } else {
    //       setIsSticky(false);
    //     }
    //   };

    //   // Event listener lagao
    //   window.addEventListener('scroll', handleScroll);

    //   // Clean-up jab component unmount ho
    //   return () => {
    //     window.removeEventListener('scroll', handleScroll);
    //   };
    // }, []);

    const isDropdownActive = ['/holiday-basket', '/europamundo-vacations'].some(path =>
        location.pathname === path || location.pathname.startsWith(`${path}/`)
    );

    const isCuriesActive = ['/our-partner-cruise-lines', '/top-sell-itineraries','/cruise/:lineSlug','/cruise-line/:lineSlug'].some(path =>
        location.pathname === path || location.pathname.startsWith(`${path}/`)
    );

    const handleNavLinkClick = () => {
        const toggleButton = document.querySelector('.navbar-toggler');
        toggleButton?.click(); 
    };

    useEffect(() => {
        const handleScroll = () => {
            const shouldBeSticky = window.scrollY > 50;
            setIsSticky(prev => {
                if (prev !== shouldBeSticky) return shouldBeSticky;
                return prev;
            });
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    return (
        <div className="container-fluid position-relative p-0">
            <nav className={`navbar navbar-expand-lg bg-white navbar-light px-4 px-lg-5 py-3 py-lg-0 ${isSticky ? 'sticky-top shadow-sm' : ''}`}>

                <NavLink to="/" className="navbar-brand p-0">
                    <img src={`${process.env.PUBLIC_URL}/img/hb-logo.png`} alt="Holiday Basket" />
                </NavLink>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                    <span className="fa fa-bars"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarCollapse">
                    <div className="navbar-nav ms-auto py-0">
                        <NavLink onClick={handleNavLinkClick} to="/" end className={({ isActive }) => `nav-item nav-link ${isActive ? 'active' : ''}`}>Home</NavLink>
                        <NavLink onClick={handleNavLinkClick} to="/packages" className={({ isActive }) => `nav-item nav-link ${isActive ? 'active' : ''}`}>Customized Holidays</NavLink>
                        <li className="nav-item dropdown">
                            <a
                               to="#"
                                className={`nav-link dropdown-toggle ${isDropdownActive ? 'active' : ''}`}
                                id="navbarDropdown"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                Escorted Group Tours
                            </a>

                            <ul className="dropdown-menu rounded-0 py-0 w-100" aria-labelledby="navbarDropdown">
                                <li>
                                    <NavLink onClick={handleNavLinkClick} to="/holiday-basket" className="dropdown-item py-3">
                                        Holiday Basket
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={handleNavLinkClick} to="/europamundo-vacations" className="dropdown-item py-3">
                                        Europamundo Vacations
                                    </NavLink>
                                </li>
                            </ul>
                        </li>

                        {/* <NavLink onClick={handleNavLinkClick} to="/" className={({ isActive }) => `nav-item nav-link ${isActive ? 'active' : ''}`}>Escorted Group Tours</NavLink> */}
                        <NavLink onClick={handleNavLinkClick} to="/visas" className={({ isActive }) => `nav-item nav-link ${isActive ? 'active' : ''}`}>Visas</NavLink>
                        {/* <NavLink onClick={handleNavLinkClick} to="/cruises" className={({ isActive }) => `nav-item nav-link ${isActive ? 'active' : ''}`}>Cruises</NavLink> */}
                        <li className="nav-item dropdown">
                            <a
                               to="#"
                                className={`nav-link dropdown-toggle ${isCuriesActive ? 'active' : ''}`}
                                id="navbarDropdown"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                Cruises
                            </a>

                            <ul className="dropdown-menu rounded-0 py-0 " aria-labelledby="navbarDropdown">
                                <li>
                                    <NavLink onClick={handleNavLinkClick} to="/our-partner-cruise-lines" className="dropdown-item py-3">
                                        OUR PARTNER CRUISE LINES
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink onClick={handleNavLinkClick} to="/top-sell-itineraries" className="dropdown-item py-3">
                                        TOP SELL ITINERARIES
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                        <NavLink onClick={handleNavLinkClick} to="/about" className={({ isActive }) => `nav-item nav-link ${isActive ? 'active' : ''}`}>About Us</NavLink>
                        <NavLink onClick={handleNavLinkClick} to="/contact" className={({ isActive }) => `nav-item nav-link ${isActive ? 'active' : ''}`}>Contact</NavLink>
                    </div>
                    {/* <a href="#" className="btn btn-primary rounded-pill py-2 px-4 ms-lg-4">Book Now</a> */}
                </div>
            </nav>
        </div>
    );
};

export default Navbar;
